import { useState } from "react";

function LoadCart() {
  const cartString = sessionStorage.getItem("shoppingCart");
  // console.log("LoadCart.cartString before if: ", cartString);
  let cart;
  if (cartString === null) {
    cart = [];
  } else {
    try {
      cart = JSON.parse(cartString);
      // console.log("LoadCart.cart in try: ", cart);
    } catch (error) {
      console.error("Error parsing shoppingCart from session storage:", error);
      cart = [];
    }
  }
  // If cart is null or not an array, initialize it as an empty array
  if (!Array.isArray(cart)) {
    // console.log("LoadCart.cart if Array before Assignment: ", cart);
    cart = [];
    // console.log("LoadCart.cart if Array after Assignment: ", cart);
  }
  return cart;
}

function SaveCart(cart) {
  sessionStorage.removeItem("shoppingCart");
  // console.log("SaveCart.cart if Array before Assignment: ", cart);
  sessionStorage.setItem("shoppingCart", JSON.stringify(cart));
  // console.log(JSON.stringify(cart));
}

export function AddReordersToCart(
  // itemDescription,
  // images,
  itemnmbr,
  unitprce,
  quantity,
  
) {
  let cart = LoadCart();
  let inCart = false;
  // console.log("AddToCart.cart on Arrival: ", cart);
  for (let i = 0; i < cart.length; i++) {
    if (cart[i].ItemNumber === itemnmbr) {
      // console.log("Item already in cart. Existing quantity:", cart[i].Quantity);
      // console.log("Added in AddToCart quantity:", quantity);
      inCart = true;
      cart[i].Quantity = parseInt(cart[i].Quantity) + parseInt(quantity);
      // console.log("AddToCart.SaveCart.cart in for loop: ", cart);
      SaveCart(cart);
      // console.log("here is your cart", cart);
      break; // Exit the loop once we find the item
    }
  }
  // console.log("AddToCart.cart after item search: ", cart);
  if (!inCart) {
    // Item not in cart, add it
    const newItems = {
      // ItemDescription: itemDescription,
      ItemNumber: itemnmbr,
      Price: unitprce,
      Quantity: quantity,
      // Images: images,
      
      
    };
    cart.push(newItems); // Add the new item to the main array
    // console.log("Item added to cart: ", newItems);
    SaveCart(cart);
    // console.log("updated cart after operation: ", cart);
  }
}


export function AddToCart(
  itemDescription,
  images,
  itemNumber,
  price,
  newQuantity,
  
) {
  let cart = LoadCart();
  let inCart = false;
  // console.log("AddToCart.cart on Arrival: ", cart);
  for (let i = 0; i < cart.length; i++) {
    if (cart[i].ItemNumber === itemNumber) {
      // console.log("Item already in cart. Existing quantity:", cart[i].Quantity);
      // console.log("Added in AddToCart quantity:", newQuantity);
      inCart = true;
      cart[i].Quantity = parseInt(cart[i].Quantity) + parseInt(newQuantity);
      // console.log("AddToCart.SaveCart.cart in for loop: ", cart);
      SaveCart(cart);
      // console.log("here is your cart", cart);
      break; // Exit the loop once we find the item
    }
  }
  // console.log("AddToCart.cart after item search: ", cart);
  if (!inCart) {
    // Item not in cart, add it
    const newItem = {
      ItemDescription: itemDescription,
      Images: images,
      ItemNumber: itemNumber,
      Price: price,
      Quantity: newQuantity,
      
    };
    cart.push(newItem); // Add the new item to the main array
    // console.log("Item added to cart: ", newItem);
    SaveCart(cart);
    // console.log("updated cart after operation: ", cart);
  }
}


export function Increment(itemNumber, cart) {
  for (let i = 0; i < cart.length; i++) {
    if (cart[i].ItemNumber === itemNumber) {
      cart[i].Quantity = cart[i].Quantity + 1;
      SaveCart(cart);
      return;
    }
  }
}

export function Remove(itemNumber, cart) {
  for (let i = 0; i < cart.length; i++) {
    if (cart[i].ItemNumber === itemNumber) {
      cart.splice(i, 1);
      SaveCart(cart);
      return;
    }
  }
}

export function Decrement(itemNumber, cart) {
  for (let i = 0; i < cart.length; i++) {
    if (cart[i].ItemNumber === itemNumber) {
      if (cart[i].Quantity === 1) {
        // console.log("Removing " + itemNumber);
        cart.splice(i, 1);
        SaveCart(cart);
        return;
      }
      cart[i].Quantity = cart[i].Quantity - 1;
      // console.log("Removing 1 from " + itemNumber + " quantity");
      SaveCart(cart);
      return;
    }
  }
}

export function GetTotal() {
  let cart = LoadCart();
  let total = 0;
  for (let i = 0; i < cart.length; i++) {
    total = total + cart[i].Quantity * cart[i].Price;
  }
  return total;
}

export function GetCount() {
  let cart = LoadCart();
  return cart.length;
}

export function GetCart() {
  return LoadCart();
}

export function ClearCart() {
  SaveCart([]);
}
